module.exports = __webpack_public_path__ + "img/4.a9d45a95.jpg";